import { useParams } from "react-router-dom";
import { LoadingIndicator } from "../../../../../../components";
import { Analysis, JoeProcessDetails, Schema } from "../../../../@types";
import { CapeProcessDetails } from "../../../../@types/cape/";
import { CuckooProcessDetails } from "../../../../@types/cuckoo";
import DynamicAnalysisGrid from "../DynamicAnalysisGrid";
import { useGetProcessDetails } from "../hooks";
import { useBehaviorContext } from "./hooks";

type Props = {
  analysis: Analysis;
  schema: Schema<unknown>;
};

const ProcessDetailsGrid = <
  T extends CuckooProcessDetails | CapeProcessDetails | JoeProcessDetails
>({
  analysis,
  schema
}: Props) => {
  const { hash, uploadId } = useParams();
  const { active } = useBehaviorContext();

  const { data, isLoading } = useGetProcessDetails<T>(
    hash,
    analysis,
    active?.process_id,
    active?.parent_process_id,
    uploadId
  );

  if (isLoading)
    return <LoadingIndicator data-testid="behavior-grid-loading-indicator" />;

  return <DynamicAnalysisGrid data={data} schema={schema} />;
};

export default ProcessDetailsGrid;
